/**
 * /annuaire/opposition/confirmer?token=... — confirme le retrait double opt-in.
 */
import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { CheckCircle2, XCircle, ShieldCheck, ArrowLeft } from 'lucide-react';
import { API, useSeoMeta, SITE_NAME } from './_shared';

export default function OppositionConfirmer() {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');

  useSeoMeta({ title: `Confirmation de retrait · ${SITE_NAME}`, canonicalPath: '/annuaire/opposition/confirmer' });

  useEffect(() => {
    if (!token) { setStatus('error'); setMessage('Aucun jeton fourni.'); return; }
    fetch(`${API}/api/annuaire/opposition/confirm?token=${encodeURIComponent(token)}`)
      .then(async r => {
        const j = await r.json();
        if (!r.ok) { setStatus('error'); setMessage(j.detail || 'Lien invalide.'); return; }
        setStatus('ok'); setMessage(j.message || 'Retrait confirmé.');
      })
      .catch(() => { setStatus('error'); setMessage('Erreur réseau.'); });
  }, [token]);

  return (
    <div className="min-h-screen bg-[#0a0a0b] text-white flex items-center justify-center p-6" data-testid="opposition-confirmer">
      <div className="max-w-md w-full rounded-2xl bg-[#141416] border border-white/10 p-8 text-center">
        {status === 'loading' && <p className="text-white/50">Vérification du lien…</p>}
        {status === 'ok' && (
          <>
            <CheckCircle2 className="w-12 h-12 text-emerald-400 mx-auto mb-3" />
            <h1 className="text-2xl font-black text-white" style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>Retrait confirmé</h1>
            <p className="text-white/60 text-[14px] mt-3">{message}</p>
            <p className="text-white/40 text-[12px] mt-3">Votre fiche est retirée de l'annuaire public. La modification sera visible en production après le prochain déploiement.</p>
          </>
        )}
        {status === 'error' && (
          <>
            <XCircle className="w-12 h-12 text-rose-400 mx-auto mb-3" />
            <h1 className="text-2xl font-black text-white" style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>Lien invalide</h1>
            <p className="text-white/60 text-[14px] mt-3">{message}</p>
          </>
        )}
        <div className="mt-6 pt-5 border-t border-white/5">
          <Link to="/auto-ecoles" className="inline-flex items-center gap-1.5 text-rose-300 hover:text-rose-200 text-[13px]">
            <ArrowLeft className="w-3.5 h-3.5" /> Retour à l'annuaire
          </Link>
        </div>
        <p className="mt-6 text-[11px] text-white/30 flex items-center justify-center gap-1"><ShieldCheck className="w-3 h-3" /> RGPD art. 21 · CODE VOITURE</p>
      </div>
    </div>
  );
}
